import { Box } from '@hover/blueprint';
import type { JwtMessage } from '@hover/embed/post-message-api';
import React from 'react';

import { TextOverlay } from 'src/modules/homeownerApp/components/Customize/TextOverlay';
import { useHomeownerTranslate } from 'src/modules/homeownerApp/hooks';
import { defaultLocalStorageAdapter } from 'src/shared/graphql/localStorageTokenAdapter';
import { useEffectOnMount } from 'src/shared/hooks';

import { LoadingTextEllipsis } from '../../LoadingText';

export const EmbedAuthCheckPopup = () => {
  const t = useHomeownerTranslate();

  useEffectOnMount(() => {
    const sendToken = async () => {
      // These need to be defined in the effect, as the window object is not available
      // server side.
      const opener = window.opener as Window | null;
      const hasValidOpener =
        opener && opener.location.origin === window.location.origin;

      if (hasValidOpener) {
        // We don't need to do a check here to see if the token is valid. The receiving window will
        // have to validate the token anyways, so we can skip an extra request.
        const jwt = await defaultLocalStorageAdapter.getAccessToken();
        const message: JwtMessage = {
          type: 'jwt',
          payload: {
            jwt,
          },
        };

        opener?.postMessage(message, window.location.origin);
      }
      window.close();
    };

    void sendToken();
  });

  return (
    <Box h="100dvh" w="100dvw">
      <TextOverlay
        alignItems="center"
        h="100dvh"
        headerColor="text.primary"
        justifyContent="center"
        w="100dvw"
      >
        <span>{t('embed.checkingOnYourAccount')}</span>
        <LoadingTextEllipsis />
      </TextOverlay>
    </Box>
  );
};
